import React, { useState } from 'react';
import styled from 'styled-components';
import AdminMainContainer from 'components/admin/search/AdminMainContainer';
import { H1NewUI } from 'styles/v2/Styles.styled';
import { withGreyBackground } from 'pages/v2/WithGreyBackground';
import GeneralInfoTab from './tabs/GeneralInfoTab';
import IndividualVerifiersTab from './tabs/IndividualVerifiersTab';
import CertificationBodiesTab from './tabs/CertificationBodiesTab';

type TabId = 'general' | 'individual' | 'bodies';

const TAB_LABELS: Record<TabId, string> = {
  general: 'General information',
  individual: 'Approved Individual Verifier',
  bodies: 'Accredited Certification Body',
};

const TAB_ORDER: TabId[] = ['general', 'individual', 'bodies'];

const ContactVerifiersPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>('general');

  return (
    <MainContainer>
      <H1NewUI style={{ marginBottom: 40 }}>Contact verifier</H1NewUI>

      <TabBar role="tablist">
        {TAB_ORDER.map((tabId) => (
          <TabButton
            key={tabId}
            role="tab"
            aria-selected={activeTab === tabId}
            $active={activeTab === tabId}
            onClick={() => setActiveTab(tabId)}
            type="button"
          >
            {TAB_LABELS[tabId]}
          </TabButton>
        ))}
      </TabBar>

      <div role="tabpanel">
        <div hidden={activeTab !== 'general'}>
          <GeneralInfoTab />
        </div>
        <div hidden={activeTab !== 'individual'}>
          <IndividualVerifiersTab />
        </div>
        <div hidden={activeTab !== 'bodies'}>
          <CertificationBodiesTab />
        </div>
      </div>
    </MainContainer>
  );
};

const MainContainer = styled(AdminMainContainer)`
  max-width: 1130px;
  padding-bottom: 60px;
`;

const TabBar = styled.div`
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 0;
`;

const TabButton = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  padding: 12px 20px;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 600;
  color: ${({ $active, theme }) => ($active ? theme.colors.primaryGreen : theme.colors.elementsButtonDisabled)};
  border-bottom: 2px solid ${({ $active, theme }) => ($active ? theme.colors.primaryGreen : 'transparent')};
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryGreen};
  }
`;

export default withGreyBackground(ContactVerifiersPage);
